var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 178,
    viewBox: "0 0 225 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG for maintenance 1",
    clipPath: "url(#clip0_5904_26045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M1.36906 51.3042C7.44033 23.0162 62.4811 48.7698 90.7181 18.3728C106.733 9.73385 137.92 13.389 150.563 23.0162C171.634 39.0614 163.819 38.1488 189.758 44.9704C235.5 57 225.139 109.565 217.152 128.565C209.165 147.565 178.594 149.5 144.663 146.298C127.765 144.704 84.5938 167.5 59.9517 146.298C47.8332 135.871 42.5917 125 37.6162 106.612C31.1991 82.8956 -3.74799 75.1462 1.36906 51.3042Z",
    fill: "#FFE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M142.449 1.5H91.4492V85.5H142.449V1.5Z",
    fill: "#FFE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M132 32.3587V53.019C132 55.4309 129.767 57.3778 127 57.3778C124.233 57.3778 122 55.4309 122 53.019V42.3257C122 39.9138 119.767 37.9669 117 37.9669C114.233 37.9669 112 39.9138 112 42.3257V53.019C112 55.4309 109.767 57.3778 107 57.3778C104.233 57.3778 102 55.4309 102 53.019V38.3447C102 35.9329 99.7667 33.986 97 33.986C94.2333 33.986 92 35.9329 92 38.3447V57.3778V60.5741V86H142V60.5741V57.3778V32.3587C142 29.9469 139.767 28 137 28C134.267 28 132 29.9469 132 32.3587Z",
    fill: "#F54E50",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M142.449 1.5H91.4492V85.5H142.449V1.5Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M116.074 136.842V129.525C116.074 124.636 120.08 120.657 125.003 120.657H151.28C156.203 120.657 160.209 116.678 160.209 111.788V104.134C160.209 99.2446 156.203 95.2656 151.28 95.2656H143.234",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M140.896 108.697H92.5591C88.927 108.697 86.0078 105.772 86.0078 102.208V88.3213C86.0078 84.7236 88.961 81.832 92.5591 81.832H140.862C144.494 81.832 147.413 84.7572 147.413 88.3213V102.208C147.447 105.772 144.494 108.697 140.896 108.697Z",
    fill: "#F54E50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.14,
    d: "M140.938 81.832H140.567C141.005 82.704 141.275 83.6767 141.275 84.7499V100.211C141.275 102.895 139.083 105.108 136.351 105.108H94.7336C92.7438 105.108 91.125 106.718 91.125 108.697H140.904C144.513 108.697 147.413 105.779 147.413 102.224V88.3722C147.447 84.7164 144.513 81.832 140.938 81.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.15,
    d: "M143.726 86.3105H90.3348C89.3486 86.3105 88.5664 85.4617 88.5664 84.3916C88.5664 83.3214 89.3486 82.4727 90.3348 82.4727H143.726C144.712 82.4727 145.494 83.3214 145.494 84.3916C145.494 85.4617 144.712 86.3105 143.726 86.3105Z",
    fill: "#F54E50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M140.896 108.697H92.5591C88.927 108.697 86.0078 105.772 86.0078 102.208V88.3213C86.0078 84.7236 88.961 81.832 92.5591 81.832H140.862C144.494 81.832 147.413 84.7572 147.413 88.3213V102.208C147.447 105.772 144.494 108.697 140.896 108.697Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M116.391 176.5C112.35 176.5 109.035 173.271 109.035 169.259V146.003C109.035 142.026 112.316 138.762 116.391 138.762C120.432 138.762 123.747 141.992 123.747 146.003V169.259C123.712 173.271 120.432 176.5 116.391 176.5Z",
    fill: "#AB5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M118.354 139.402C119.372 140.648 120.017 142.23 120.017 143.947V166.974C120.017 170.913 116.794 174.145 112.789 174.145C112.145 174.145 111.534 174.044 110.957 173.909C112.28 175.491 114.282 176.501 116.522 176.501C120.492 176.501 123.75 173.303 123.75 169.331V146.304C123.716 143.005 121.442 140.21 118.354 139.402Z",
    fill: "#9B4F45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M116.391 176.5C112.35 176.5 109.035 173.271 109.035 169.259V146.003C109.035 142.026 112.316 138.762 116.391 138.762C120.432 138.762 123.747 141.992 123.747 146.003V169.259C123.712 173.271 120.432 176.5 116.391 176.5Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M120.597 140.682H112.185C110.454 140.682 109.035 139.241 109.035 137.483C109.035 135.726 110.454 134.285 112.185 134.285H120.597C122.328 134.285 123.747 135.726 123.747 137.483C123.747 139.241 122.328 140.682 120.597 140.682Z",
    fill: "#9B4F45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M120.515 134.285H115.434C117.21 134.285 118.667 135.726 118.667 137.483C118.667 139.241 117.21 140.682 115.434 140.682H120.515C122.292 140.682 123.749 139.241 123.749 137.483C123.749 135.726 122.292 134.285 120.515 134.285Z",
    fill: "#8C443E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M120.597 140.682H112.185C110.454 140.682 109.035 139.241 109.035 137.483C109.035 135.726 110.454 134.285 112.185 134.285H120.597C122.328 134.285 123.747 135.726 123.747 137.483C123.747 139.241 122.328 140.682 120.597 140.682Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M86.0078 100.383H85.624C84.4087 100.383 83.4492 99.3251 83.4492 98.0629V92.4682C83.4492 91.1719 84.4407 90.1484 85.624 90.1484H86.0078V100.383Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M86.0078 100.383H85.624C84.4087 100.383 83.4492 99.3251 83.4492 98.0629V92.4682C83.4492 91.1719 84.4407 90.1484 85.624 90.1484H86.0078V100.383Z",
    fill: "#414244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M147.414 100.383H147.894C149.413 100.383 150.612 99.3251 150.612 98.0629V92.4682C150.612 91.1719 149.373 90.1484 147.894 90.1484H147.414V100.383Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M147.414 100.383H147.894C149.413 100.383 150.612 99.3251 150.612 98.0629V92.4682C150.612 91.1719 149.373 90.1484 147.894 90.1484H147.414V100.383Z",
    fill: "#414244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M117.363 24.9881L113.673 19.4411C111.725 16.5289 113.536 12.438 117.021 12.1953C117.124 12.1953 117.26 12.1953 117.363 12.1953C117.465 12.1953 117.602 12.1953 117.704 12.1953C121.155 12.438 122.966 16.4942 121.053 19.4411L117.363 24.9881Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M117.363 25.5467L113.673 19.9997C111.725 17.0875 113.536 12.9966 117.021 12.7539C117.124 12.7539 117.26 12.7539 117.363 12.7539C117.465 12.7539 117.602 12.7539 117.704 12.7539C121.155 12.9966 122.966 17.0528 121.053 19.9997L117.363 25.5467Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.4,
    d: "M94.9648 88.2305H123.749",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.4,
    d: "M129.504 88.2305H133.342",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M116.391 170.743C117.627 170.743 118.63 169.741 118.63 168.504C118.63 167.268 117.627 166.266 116.391 166.266C115.155 166.266 114.152 167.268 114.152 168.504C114.152 169.741 115.155 170.743 116.391 170.743Z",
    fill: "#3E454F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M116.391 170.743C117.627 170.743 118.63 169.741 118.63 168.504C118.63 167.268 117.627 166.266 116.391 166.266C115.155 166.266 114.152 167.268 114.152 168.504C114.152 169.741 115.155 170.743 116.391 170.743Z",
    stroke: "#414244",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5904_26045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 178,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.720c111d21bc0e5b625c632e74846a4c.svg";
export { ForwardRef as ReactComponent };